import { createContext, useContext, useEffect, useState, ReactNode } from "react";

type Theme = "light" | "dark";

interface ThemeContextType {
  theme: Theme;
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export function ThemeProvider({ children }: { children: ReactNode }) {
  // Always initialize with dark theme
  const [theme, setTheme] = useState<Theme>("dark");

  useEffect(() => {
    // Save to localStorage
    localStorage.setItem("theme", theme);
    
    // Update DOM
    const root = window.document.documentElement;
    
    // Always add dark class
    root.classList.add("dark");
  }, [theme]);

  const toggleTheme = () => {
    // Keep dark theme even when toggled
    setTheme("dark");
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
}
